import { Box, Typography, Link as MUILink, IconButton, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import Image from './image';
import logo from '../../assets/logo.png';
import TwitterIcon from '../../assets/icons/twitter.svg';
import FaqsIcon from '../../assets/icons/Faqs.svg';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import DiscordIcon2 from '../../icons/DiscordIcon';
import Blog from '../../assets/icons/blog.svg';
import Discord from '../../assets/icons/discord.svg';
import Description from '../../assets/icons/descriptionn.svg';
import Contact from '../../assets/icons/Contact.svg';

export default function SLPFooter() {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();
  // const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const footerLinks = [
    { label: 'Blog', to: '/blog', icon: <Image src={Blog} alt="Blog Icon" width={12} height={12} /> },
    { label: 'FAQs', to: '/faq', icon: <Image src={FaqsIcon} alt="FAQ Icon" width={12} height={12} /> },
    { label: 'Docs', to: 'https://saagasai.mintlify.app', icon: <Image src={Description} alt="FAQ Icon" width={18} height={18} /> },
    { label: 'Discord', to: 'https://t.co/401XPwdXQx', icon: <Image src={Discord} alt="Discord Icon" width={18} height={18} /> },
    { label: 'Contact Us', to: 'mailto:support@saagas.ai', icon: <Image src={Contact} alt="Discord Icon" width={13} height={10} /> }
    // { label: 'Contact Us', to: 'mailto:support@saagas.ai', icon: <MailOutlineIcon />, external: true }
    // { label: 'Discord', to: 'https://t.co/401XPwdXQx', icon: <DiscordIcon2 style={{ width: 20, height: 20 }} />, external: true }
  ];

  const policyLinks = [
    { label: 'Privacy Policy', to: '/privacy-policy' },
    { label: 'Terms & Conditions', to: '/terms-of-use' }
  ];

  const socialLinks = [
    {
      label: 'X profile',
      href: 'https://x.com/saagasinfluencr',
      icon: <Image src={TwitterIcon} alt="X Icon" width={13} height={15} />
    },
    {
      label: 'Discord server',
      href: 'https://t.co/401XPwdXQx',
      icon: <DiscordIcon2 style={{ width: 20, height: 20 }} />
    },
    {
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/company/saagasai/',
      icon: <LinkedInIcon style={{ width:15, height: 15 }} />
    },
    {
      label: 'Instagram',
      href: 'https://www.instagram.com/saagas.ugc/',
      icon: <InstagramIcon style={{ width: 15, height: 15 }} />
    }
  ];

  return (
    <Box
      component="footer"
      sx={{
        px: { xs: 2, md: 5 },
        py: 5,
        maxWidth: '1440px',
        m: 'auto',
        backgroundColor: '#000000'
      }}
    >
      {/* Mobile view structure */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          margin: 'auto',
          maxWidth: '1260px',

          // Desktop view
          [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 0
          }
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            mb: { xs: 3.5, md: 0 },

            [theme.breakpoints.up('md')]: {
              width: 'auto',
              justifyContent: 'flex-start'
            }
          }}
        >
          <Link to="#home"  onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}>
            <Image src={logo} alt="Saagas.ai logo" width={32} height={32} className="w-[20px] h-[27px] sm:w-[32px] sm:h-[32px]" />
          </Link>
        </Box>

        {/* Navigation Links - Each on its own line for mobile */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            gap: { xs: 2, md: 4 },

            [theme.breakpoints.up('md')]: {
              flexDirection: 'row',
              justifyContent: 'center',
              flexWrap: 'wrap',
              gap: 3
            }
          }}
        >
          {/* Split Footer Links */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: { xs: 2, md: 5 },

              [theme.breakpoints.up('md')]: {
                flexDirection: 'row',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 3
              }
            }}
          >
            {/* First 3 Links in Row */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: { xs: "40px", md: 3 },
                ml: { xs: 0, md: 0, lg: 10 },
                pb:{xs:2.5,sm:1}
              }}
            >
              {footerLinks.slice(0, 3).map(({ label, to, icon }) => (
                <MUILink
                  key={label}
                  component={to.startsWith('http') ? 'a' : Link}
                  href={to.startsWith('http') ? to : undefined}
                  to={!to.startsWith('http') ? to : undefined}
                  underline="none"
                  target={to.startsWith('http') ? '_blank' : undefined}
                  rel={to.startsWith('http') ? 'noopener noreferrer' : undefined}
                  sx={{
                    fontSize: '14px',
                    color: '#FFFFFF',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5
                  }}
                >
                  {icon}
                  {label}
                </MUILink>
              ))}
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'row', md: 'row' },
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: { xs: '45px', md: 3 },
                pb:{xs:2.5,sm:1}

              }}
            >
              {footerLinks.slice(3).map(({ label, to, icon }) => (
                <MUILink
                  key={label}
                  component={to.startsWith('http') ? 'a' : Link}
                  href={to.startsWith('http') ? to : undefined}
                  to={!to.startsWith('http') ? to : undefined}
                  underline="none"
                  target={to.startsWith('http') ? '_blank' : undefined}
                  rel={to.startsWith('http') ? 'noopener noreferrer' : undefined}
                  sx={{
                    fontSize: '14px',
                    color: '#FFFFFF',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5
                  }}
                >
                  {icon}
                  {label}
                </MUILink>
              ))}
            </Box>
          </Box>
        </Box>

        {/* Social Media Icons */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: { xs: 0, md: 3 },
            mt: { xs: '12px', md: 0 },
            mb: { xs: '16px', md: 0 },
            [theme.breakpoints.up('md')]: {
              justifyContent: 'flex-end'
            }
          }}
        >
          {socialLinks.map(({ label, href, icon }) => (
            <IconButton key={label} component={MUILink} href={href} target="_blank" aria-label={label} sx={{ color: '#FFFFFF', width: 33, height: 35,  }}>
              {icon}
            </IconButton>
          ))}
        </Box>
      </Box>
      <Box sx={{ borderBottom: '1px solid #18181B', width: '100%', my: 2 }} />
      {/* Bottom Section with Copyright and Policies */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          margin: 'auto',
          maxWidth: '1260px',
          pt: 1,

          [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: 0
          }
        }}
      >
        {/* Copyright Text */}
        <Typography
          variant="body2"
          sx={{
            color: '#A8A8A8',
            fontSize: '14px',
            textAlign: 'center',
            order: { xs: 2, md: 1 },
            mt: { xs: 2, md: 0 }
          }}
        >
          © Copyright {currentYear}, All Rights Reserved
        </Typography>

        {/* Policy Links */}
        <Box
          sx={{
            display: 'flex',
            gap: 3,
            order: { xs: 1, md: 2 },

            [theme.breakpoints.up('md')]: {
              ml: 'auto'
            }
          }}
        >
          {policyLinks.map(({ label, to }) => (
            <MUILink
              key={label}
              component={Link}
              to={to}
              underline="none"
              sx={{
                fontSize: '14px',
                color: '#A8A8A8'
              }}
            >
              {label}
            </MUILink>
          ))}
        </Box>
      </Box>
    </Box>
  );
}